import React from "react";
import PremiumResourcePage from "../../../Components/Dashboard/PremiumResourcePage";

const SalesPerson = ({ navigation }) => (
  <PremiumResourcePage
    navigation={navigation}
    title="Sales Persons"
    subtitle="View and manage sales team members assigned to customers and transactions."
    fetchEndpoint="/getAllSalesPersonByUniqueId"
    transformRows={(rows) => (rows || []).filter((item) => item.name !== "Others")}
    deleteEndpoint="/deleteSalesperson/:id"
    deleteKey="id"
    columns={[
      { key: "serial", label: "Serial No." },
      { key: "name", label: "Name" },
      { key: "email", label: "Email" },
    ]}
  />
);

export default SalesPerson;
